import './styles.scss'

import { Button, type ButtonProps as AntButtonProps } from 'antd'
import clsx from 'clsx'
import type { ReactNode } from 'react'

import { ChevronLeftIcon } from '../Icons'

type IconComponent = React.ComponentType<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>>

type ExtendedButtonType = 'primary' | 'default' | 'dashed' | 'link' | 'text' | 'ghost' | 'action'

interface CustomButtonProps extends Omit<AntButtonProps, 'type' | 'onClick' | 'icon'> {
  children?: ReactNode
  isQuantity?: boolean
  isPriceBox?: boolean
  onClick?: () => void
  disabled?: boolean
  className?: string
  type?: ExtendedButtonType
  isInverted?: boolean
  buttonSize?: 'default' | 'small' | 'large'
  isPriceEqualZero?: boolean
  icon?: IconComponent
}

const CustomButton = ({
  children,
  isQuantity = false,
  isPriceBox = false,
  onClick = () => {},
  disabled = false,
  className = '',
  type = 'primary',
  isInverted = false,
  buttonSize = 'default',
  icon: Icon,
  ...rest
}: CustomButtonProps) => {
  const classNames = clsx('custom-button', 'kaercher-button', className, {
    'custom-button--quantity': isQuantity,
    'custom-button--price-box': isPriceBox,
    'custom-button--small': buttonSize === 'small',
    'custom-button--large': buttonSize === 'large',
    inverted: isInverted,
  })

  return (
    <Button
      {...rest}
      type={type as AntButtonProps['type']}
      className={classNames}
      onClick={onClick}
      disabled={disabled}
    >
      {Icon && <Icon className="custom-button__icon" />}
      {children}
    </Button>
  )
}

export const BackButton = ({ children, ...props }: Omit<CustomButtonProps, 'icon'>) => {
  return (
    <CustomButton icon={ChevronLeftIcon} {...props}>
      {children}
    </CustomButton>
  )
}

export default CustomButton
